import { render, staticRenderFns } from "./PlaypositErrorScreen.vue?vue&type=template&id=70547a94&scoped=true"
import script from "./PlaypositErrorScreen.vue?vue&type=script&lang=js"
export * from "./PlaypositErrorScreen.vue?vue&type=script&lang=js"
import style0 from "./PlaypositErrorScreen.vue?vue&type=style&index=0&id=70547a94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../microservices/playlist/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70547a94",
  null
  
)

export default component.exports